import {commitMutation, graphql} from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation CreateReportQuestionFilterMutation(
    $input: CreateReportQuestionFilterInput!
  ) {
    createReportQuestionFilter(input: $input) {
      report {
        id
        filters {
          type
          text {
            language
            text
          }
          question {
            id
            text {
              language
              text
            }
            options {
              value
              text {
                language
                text
              }
            }
          }
          locked
        }
      }
    }
  }
`;

function commit({reportId, questionMongoId}) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          reportId,
          questionMongoId,
        },
      },
    },
  );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/CreateReportQuestionFilterMutation.js